import {
    BudgetCategoryGroupFieldsFragment,
    BudgetPurpose,
    TransactionEntryCategoryGroupFieldsFragment,
} from '../../graphql/generated';
import { buildBudgetCategoryGroupMap } from './buildBudgetCategoryGroupMap';

export const filterTransactionEntryCategoryGroupsForBudgetPurpose = <
    T extends TransactionEntryCategoryGroupFieldsFragment,
>({
    budgetCategoryGroups,
    transactionEntryCategoryGroups,
    budgetPurpose,
}: {
    budgetCategoryGroups: BudgetCategoryGroupFieldsFragment[];
    transactionEntryCategoryGroups: T[];
    budgetPurpose: BudgetPurpose;
}) => {
    const budgetCategoryGroupMap =
        buildBudgetCategoryGroupMap(budgetCategoryGroups);

    return transactionEntryCategoryGroups.filter((group) => {
        const budgetCategoryGroup = budgetCategoryGroupMap[group.id];

        // If there's a budget category group, use its purpose
        // Otherwise fall back to the default purpose
        return budgetCategoryGroup
            ? budgetCategoryGroup.budgetPurpose === budgetPurpose
            : group.defaultBudgetPurpose === budgetPurpose;
    });
};
